module.exports = __webpack_public_path__ + "img/base_green.0d93a018.svg";